/* eslint-disable no-unused-vars */
import _ from 'lodash'


function getRGBA(color) {
  const {r,g,b,a} = color

  const rr = r > 0 ?  Math.floor(255*r) : 0
  const gg = g > 0 ?  Math.floor(255*g) : 0
  const bb = b > 0 ?  Math.floor(255*b) : 0

  if(rr > 255 || gg > 255 || bb > 255)
    return `rgba(${r}, ${g}, ${b}, ${a})`; // this is an error

  return `rgba(${rr}, ${gg}, ${bb}, ${a})`;
}

export function getLineFeatures(session, drawSettings) {
  console.log('session',session)
  // console.log('session',session.g)
  // return
  // let returnObj = {}
  let features = []
  // let featuresCoordinates = []

  // filter out sessions without l data and create coordinates array
  // _cleanSessions(geoFire)



    const startingCoordinate = [round(session.l[1], 6), round(session.l[0], 6)];

    // add lines to map
    _.map(session.lines, (line, lineKey) => {

      const lineFeature = {
        "type": "Feature",
        "geometry": {
          "type": "LineString",
          "coordinates": _getLineCoordinates(startingCoordinate, line.line, drawSettings)
        },
        "properties" : {
          "id": lineKey,
          "userId": session.userId,
          "size" : line.size || 'NO SIZE',
          // "timestamp" : session.time*1000,
          "color": getRGBA(line.color),
          "width": getWidth(line.size,drawSettings.widthFactor),
        }
      }
      if(line.size !== 30) {
        // console.warn('NEW SIZE!!!!!!!',line.size)

      }
      features.push(lineFeature);
    });

    return features;
}

function getWidth(size,factor) {
  console.log(size)
  let width = 1;
  if(size > 20) { width = 3; }
  if(size >= 30) { width = 4; }
  if(size > 40) { width = 5; }
  if(size > 50) { width = 6; }
  if(size > 60) { width = 8; }

  return width * factor;
}


function _getLineCoordinates(startingCoordinate, lineTransform, drawSettings) {

  let lineCoordinates = []
  const {xFactor, yFactor, xOffset, yOffset, flipH, flipV} = drawSettings
  // console.log('yOffset',parseFloat(yOffset))
  // lineTransform = _.reverse(lineTransform)

  _.forEach(lineTransform, (dot, i) => {

    const xPoint = Math.floor(lineTransform[i].x)
    const yPoint = Math.floor(lineTransform[i].y)

    let newLat = startingCoordinate[0] + (xFactor * xPoint) + parseFloat(xOffset)
    let newLong = startingCoordinate[1] + (yFactor * yPoint) + parseFloat(yOffset)

    lineCoordinates.push([newLat,newLong])

  });

  return lineCoordinates;
}

function round(x, n) {
  const tenN = Math.pow(10, n);
  return Math.round(x * tenN) / tenN;
}



// WEBPACK FOOTER //
// ./src/components/pages/Edit/utils.js